
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "eye.icon",
  "use": "eye.icon-usage",
  "viewBox": "0 0 24 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 16\" id=\"eye.icon\"><path d=\"M12 5.714c-1.205 0-2.182 1.022-2.182 2.286 0 1.262.977 2.284 2.182 2.284S14.18 9.262 14.18 8c0-1.264-.975-2.286-2.18-2.286zM12 0C5.07 0 0 8 0 8s5.07 8 12 8 12-8 12-8-5.07-8-12-8zm0 12.57c-2.41 0-4.363-2.044-4.363-4.57 0-2.526 1.953-4.572 4.363-4.572 2.409 0 4.365 2.046 4.365 4.572 0 2.526-1.956 4.57-4.365 4.57z\" id=\"eye.icon_Fill-1\" /></symbol>"
});
    sprite.add(symbol);
    export default class EyeIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="eye.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/eye.icon.svg